// ═══ 검차 셸 오류 문구 — code 우선, 서버 한글 message 노출 금지 (앱 simple_error.dart 재현) ═══
// 주 사용자가 외국인 바이어라 백엔드 한국어 문구가 화면에 새면 안 된다.
// 결정 11 — code 문자열 자체도 표시하지 않는다(진단용 칩은 시안에만 있던 것).

var HANGUL = /[가-힣]/;

var CODE_KEY = {
  DUP_LISTING_URL: 'simpleB3LinkDupTitle',
  DUP_CAR_NUMBER: 'simpleDupTitle',
  INVALID_URL: 'simpleB3LinkInvalid',
  INVALID_PHOTO: 'simpleB4TooMany',
  COMPANY_REQUIRED: 'errorGeneric',
  INVALID_MONTH: 'errorGeneric',
  EVAL_COMPLETED: 'errorGeneric',
  NOT_OPEN: 'simpleFeeAdjustNotOpen',
  BELOW_MIN: 'simpleFeeAdjustBelowMin',
  INVALID_DELTA: 'errorGeneric'
};

export function describeSimpleError(t, err) {
  if (!err) return t('errorGeneric');
  var key = CODE_KEY[err.code];
  if (key) return t(key);
  var message = err.message || '';
  if (!message || HANGUL.test(message)) return t('errorGeneric');
  return message;
}

export default describeSimpleError;
